import { render, staticRenderFns } from "./scxg.vue?vue&type=template&id=379ef65e&scoped=true"
import script from "./scxg.vue?vue&type=script&lang=js"
export * from "./scxg.vue?vue&type=script&lang=js"
import style0 from "./scxg.vue?vue&type=style&index=0&id=379ef65e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379ef65e",
  null
  
)

export default component.exports